import { createFileRoute, redirect } from '@tanstack/react-router'
import { searchState } from '../../WorkspaceContext'

export const Route = createFileRoute('/data/$schema')({
  validateSearch: search => searchState.parse(search),
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/data', search: { ...search, schema: undefined }, replace: true })
  },
})
